import script from "./AgentChatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentChatPage.vue?vue&type=script&setup=true&lang=js"

import "./AgentChatPage.vue?vue&type=style&index=0&id=e2a5d6e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2a5d6e6"]])

export default __exports__